/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Execute_Output7Inputs */

const en_svc_programmatic_seo_execute_output7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indexed pages`)
};

const ar_svc_programmatic_seo_execute_output7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صفحات مفهرسة`)
};

const bn_svc_programmatic_seo_execute_output7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইনডেক্সড পৃষ্ঠা`)
};

const de_svc_programmatic_seo_execute_output7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indexierte Seiten`)
};

const es_svc_programmatic_seo_execute_output7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Páginas indexadas`)
};

const fr_svc_programmatic_seo_execute_output7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pages indexées`)
};

const pt_svc_programmatic_seo_execute_output7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Páginas indexadas`)
};

const zh_svc_programmatic_seo_execute_output7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已收录页面`)
};

const tr_svc_programmatic_seo_execute_output7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dizine giren sayfalar`)
};

const ru_svc_programmatic_seo_execute_output7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проиндексированные страницы`)
};

const pl_svc_programmatic_seo_execute_output7 = /** @type {(inputs: Svc_Programmatic_Seo_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaindeksowane strony`)
};

/**
* | output |
* | --- |
* | "Indexed pages" |
*
* @param {Svc_Programmatic_Seo_Execute_Output7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_execute_output7 = /** @type {((inputs?: Svc_Programmatic_Seo_Execute_Output7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Execute_Output7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_execute_output7(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_execute_output7(inputs)
	if (locale === "de") return de_svc_programmatic_seo_execute_output7(inputs)
	if (locale === "es") return es_svc_programmatic_seo_execute_output7(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_execute_output7(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_execute_output7(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_execute_output7(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_execute_output7(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_execute_output7(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_execute_output7(inputs)
	return en_svc_programmatic_seo_execute_output7(inputs)
});
export { svc_programmatic_seo_execute_output7 as "svc_programmatic-seo_EXECUTE_output" }